// ============================================================================
// ARCHIVO COMENTADO: Funcionalidad de notificaciones incompleta
// Este módulo consume recursos innecesarios en Firebase
// Descomentar cuando la funcionalidad esté completa y lista para usar
// ============================================================================

import React, { createContext, useContext, useState } from 'react';
import { 
  type Notificacion,
  type ConteoNotificaciones
} from '../../servicios/notificaciones/servicios';

interface NotificacionesContextType {
  notificaciones: Notificacion[];
  conteo: ConteoNotificaciones | null;
  loading: boolean;
  error: string | null;
  
  // Funciones mock
  cargarNotificaciones: (categoria?: string, limit?: number, offset?: number) => Promise<void>;
  actualizarConteo: () => Promise<void>;
  marcarComoLeida: (notificacionId: string) => Promise<void>;
  marcarVariasComoLeidas: (notificacionIds: string[]) => Promise<void>;
  eliminar: (notificacionId: string) => Promise<void>;
  marcarTodasComoLeidas: () => Promise<void>;
  refrescar: () => Promise<void>;
}

const NotificacionesContext = createContext<NotificacionesContextType | undefined>(undefined);

export const NotificacionesProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [notificaciones] = useState<Notificacion[]>([]);
  const [conteo] = useState<ConteoNotificaciones | null>(null);
  const [loading] = useState(false);
  const [error] = useState<string | null>(null);

  // Funciones mock que no hacen nada
  const cargarNotificaciones = async () => {};
  const actualizarConteo = async () => {};
  const marcarComoLeida = async () => {};
  const marcarVariasComoLeidas = async () => {};
  const eliminar = async () => {};
  const marcarTodasComoLeidas = async () => {};
  const refrescar = async () => {};

  const value: NotificacionesContextType = {
    notificaciones,
    conteo,
    loading,
    error,
    cargarNotificaciones,
    actualizarConteo,
    marcarComoLeida,
    marcarVariasComoLeidas,
    eliminar,
    marcarTodasComoLeidas,
    refrescar
  };

  return (
    <NotificacionesContext.Provider value={value}>
      {children}
    </NotificacionesContext.Provider>
  );
};

export const useNotificaciones = (): NotificacionesContextType => {
  const context = useContext(NotificacionesContext);
  if (context === undefined) {
    throw new Error('useNotificaciones debe ser usado dentro de un NotificacionesProvider');
  }
  return context;
};
